export const ParagraphTextService = Symbol('ParagraphTextService');

export interface ParagraphTextService<T> {
    /**
     * 获取段落文本
     */
    getParagraphText: () => string;

    /**
     * 设置段落文本
     */
    updateParagraphText: (text: string) => void;

    /**
     * 获取段落文文本类型
     */
    getParagraphTextType: () => T;

    /**
     * 设置段落文本类型
     */
    updateParagraphTextType: (type: T) => void;
}
